import React from "react";
import img1 from "../../assets/images/png/Education.jpg";
import img2 from "../../assets/images/png/Entertainment.jpg";
import img3 from "../../assets/images/png/Spirituality & Tourism.jpg";
import img4 from "../../assets/images/png/Real Estate.jpg";

const VrMedia = () => {
  return (
    <div className="py-5" style={{ backgroundColor: "transparent" }}>
      <div className="container">
        <h1 className="fs_44 fw-bold text-center mb-3" style={{ color: "#f8fafc" }}>
          Immersive Media: The AR/VR Frontier at{" "}
          <span className="clr_theme">HKI Media</span>
        </h1>
        <p className="fs_16 text_justify mx-auto col-xl-9 mb-3" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
          At HKI Media, we’re building the future of storytelling through{" "}
          <strong>immersive experiences&nbsp;</strong> that blend{" "}
          <strong>reality and imagination.</strong>&nbsp; With India’s creative
          economy exploding, AR/VR is no longer an add-on—it’s the{" "}
          <strong>next content revolution</strong>. The global AR/VR market is
          projected to surpass <strong>$850 billion by 2030&nbsp;</strong>, and
          HKI is poised to lead India’s leap into this immersive era with
          cutting-edge tech, in-house trained talent, and end-to-end execution.
        </p>
        <div className="text-center mb-2">
          <h3 className="ff_p fw-semibold fs_30" style={{ color: "#f8fafc" }}>
            <span className="clr_theme">AR/VR</span> Impact Zones
          </h3>
        </div>
        <div className="row mt-3">
          <div className="col-sm-6 d-flex flex-column gap-4 mt-4 mt-sm-2 pt-3">
            <div className="position-relative overflow-hidden image_position">
              <img
                loading="lazy"
                decoding="async"
                height={300}
                src={img1}
                alt="Education"
                className="w-100 object-fit-cover img_h"
              />
              <div className="position-absolute bg_red_gradient start-0 w-100 h-100 d-flex flex-column justify-content-end align-items-center text_position text-white">
                <h3 className="text-white ff_p fw-semibold fs_30">Education</h3>
                <p className="mb-0 fs_16 max_w_331 text-center pb-3">
                  Virtual classrooms, skill simulations, career-ready training
                  modules
                </p>
              </div>
            </div>
            <div className="position-relative overflow-hidden image_position">
              <img
                loading="lazy"
                decoding="async"
                height={300}
                src={img2}
                alt="Education"
                className="w-100  object-fit-cover"
              />
              <div className="position-absolute bg_red_gradient start-0 w-100 h-100 d-flex flex-column justify-content-end align-items-center text_position text-white">
                <h3 className="text-white ff_p fw-semibold fs_30">
                  Entertainment{" "}
                </h3>
                <p className="mb-0 fs_16 max_w_331 text-center pb-3">
                  VR films, music environments, gamified content journeys
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 d-flex flex-column gap-4 mt-4 mt-md-5 pt-lg-5">
            <div className="position-relative overflow-hidden image_position mt-lg-5">
              <img
                loading="lazy"
                decoding="async"
                height={300}
                src={img3}
                alt="Education"
                className="w-100  object-fit-cover"
              />
              <div className="position-absolute bg_red_gradient start-0 w-100 h-100 d-flex flex-column justify-content-end align-items-center text_position text-white">
                <h3 className="text-white ff_p fw-semibold fs_30">
                  Spirituality & Tourism{" "}
                </h3>
                <p className="mb-0 fs_16 max_w_331 text-center pb-3">
                  360° darshan experiences, heritage temple walkthroughs,
                  cultural preservation
                </p>
              </div>
            </div>
            <div className="position-relative overflow-hidden image_position">
              <img
                loading="lazy"
                decoding="async"
                height={300}
                src={img4}
                alt="Education"
                className="w-100  object-fit-cover"
              />
              <div className="position-absolute bg_red_gradient start-0 w-100 h-100 d-flex flex-column justify-content-end align-items-center text_position text-white">
                <h3 className="text-white ff_p fw-semibold fs_30">
                  Real Estate{" "}
                </h3>
                <p className="mb-0 fs_16 max_w_331 text-center pb-3">
                  Virtual walkthroughs, digital twins, sales enablement tools
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VrMedia;
